function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7 13.75A6.75 6.75 0 107 .25a6.75 6.75 0 000 13.5zm.75-9v3h-1.5v-3h1.5zm0 3.75V10h-1.5V8.5h1.5z",
  fill: "#fff"
});

var SvgIconAlertExclamationWhite = function SvgIconAlertExclamationWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03IDEzLjc1QzEwLjcyNzkgMTMuNzUgMTMuNzUgMTAuNzI3OSAxMy43NSA3QzEzLjc1IDMuMjcyMDggMTAuNzI3OSAwLjI1IDcgMC4yNUMzLjI3MjA4IDAuMjUgMC4yNSAzLjI3MjA4IDAuMjUgN0MwLjI1IDEwLjcyNzkgMy4yNzIwOCAxMy43NSA3IDEzLjc1Wk03Ljc1IDQuNzVWNy43NUg2LjI1VjQuNzVINy43NVpNNy43NSA4LjVWMTBINi4yNVY4LjVINy43NVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { SvgIconAlertExclamationWhite as ReactComponent };